/* unplugin-vue-components disabled */import { render } from "./icon_people.vue?vue&type=template&id=e79d92c6&scoped=true"
const script = {}

import "./icon_people.vue?vue&type=style&index=0&id=e79d92c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79d92c6"]])

export default __exports__